import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { jurisdiction } from '../../config/taxPlannerJurisdiction';

function Disclaimers() {
  const { t } = useTranslation();
  const snapshot = useSelector((state) => state.taxPlanner.snapshot);
  if (!snapshot) return null;
  return (
    <section data-testid="disclaimers" className="rounded-[15px] border border-dashed border-border bg-surface-muted px-5 py-[18px]">
      <p className="text-[11px] font-semibold uppercase tracking-[.06em] text-text-muted">{t('taxPlanner.scr02.disclaimersEyebrow')}</p>
      <ol className="mt-2.5 flex list-decimal flex-col gap-1.5 pl-[18px] text-[13px] text-text marker:text-xs marker:text-text-muted">
        {jurisdiction.disclaimerKeys.map((key) => (
          <li key={key}>{t(`taxPlanner.disclaimers.${key}`, { defaultValue: t('taxPlanner.disclaimers.unknown') })}</li>
        ))}
      </ol>
    </section>
  );
}

export default Disclaimers;
